<div class="provision-button">
    <fui-commands [title]="title">
        <fui-command [title]="title"
                     [disabled]="disabled"
                     (clicked$)="clicked.emit($event)"></fui-command>
    </fui-commands>
</div>
